// src/components/draft/DraftErrorBoundary.js
// Error boundary to prevent draft room crashes from losing the entire UI
import React from 'react';
import { dynastyTheme } from '../../services/colorService';
import { AlertCircle, RefreshCw } from 'lucide-react';

class DraftErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error('Draft Error Boundary caught error:', error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className={`min-h-screen ${dynastyTheme.classes.bg.dark} flex items-center justify-center p-4`}>
          <div className={`${dynastyTheme.components.card.base} max-w-md p-6 text-center`}>
            <AlertCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h2 className={`text-xl font-bold text-red-500 mb-2`}>
              Draft Room Error
            </h2>
            <p className={`${dynastyTheme.classes.text.neutralLight} mb-4`}>
              Something went wrong in the draft room. Your draft progress is saved on the server.
            </p>
            <p className={`${dynastyTheme.classes.text.neutralDark} text-sm mb-6`}>
              {this.state.error?.message || 'Unknown error'}
            </p>
            <button
              onClick={() => window.location.reload()}
              className={`${dynastyTheme.components.button.primary} flex items-center gap-2 mx-auto px-4 py-2`}
            >
              <RefreshCw className="w-4 h-4" />
              Reload Draft Room
            </button>
          </div>
        </div>
      );
    }

    return this.props.children;
  }
}

export default DraftErrorBoundary;
